import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { botInfo } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { ShieldCheck, Bot, Key, Server } from "lucide-react";

export default function Settings() {
    const [bot, setBot] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setBot(await botInfo());
            } catch {}
        })();
    }, []);

    return (
        <div className="space-y-4 md:space-y-6">
            <div>
                <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">إعدادات البوت</h1>
                <p className="mt-1 text-sm text-muted-foreground">
                    معلومات البوت والتكوين
                </p>
            </div>

            <Card className="bg-card/60 backdrop-blur">
                <CardHeader>
                    <CardTitle className="flex items-center gap-2 text-base">
                        <Bot className="h-4 w-4" />
                        معلومات البوت
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                    {bot ? (
                        <div className="space-y-2 text-sm">
                            <div className="flex items-center justify-between">
                                <span className="text-muted-foreground">الحالة</span>
                                <Badge
                                    variant="outline"
                                    className={
                                        bot.status === "running"
                                            ? "text-emerald-300 bg-emerald-500/10 border-emerald-500/20"
                                            : "text-rose-300 bg-rose-500/10 border-rose-500/20"
                                    }
                                >
                                    {bot.status}
                                </Badge>
                            </div>
                            <Separator />
                            <div className="flex items-center justify-between">
                                <span className="text-muted-foreground">Username</span>
                                <span className="font-mono" dir="ltr">@{bot.username}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-muted-foreground">ID</span>
                                <span className="font-mono" dir="ltr">{bot.id}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-muted-foreground">يستطيع قراءة الرسائل</span>
                                <Badge variant="outline">
                                    {bot.can_read_all_group_messages ? "نعم" : "لا (يحتاج تفعيل Privacy Mode)"}
                                </Badge>
                            </div>
                        </div>
                    ) : (
                        <p className="text-sm text-muted-foreground">جاري التحميل…</p>
                    )}
                </CardContent>
            </Card>

            <Card className="bg-card/60 backdrop-blur">
                <CardHeader>
                    <CardTitle className="flex items-center gap-2 text-base">
                        <ShieldCheck className="h-4 w-4" />
                        وضع الحماية الافتراضي
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li>• Anti-Raid: 10 إنضمام/دقيقة → إنذار</li>
                        <li>• Anti-Flood: 8 رسائل/10 ثواني (ضعف لـ Premium)</li>
                        <li>• CAPTCHA: 60 ثانية للإجابة (Premium يتجاوز تلقائياً)</li>
                        <li>• AI Detection: متوقف افتراضياً (فعّله للمجموعات الحساسة)</li>
                        <li>• Bulk Add Mode: 30 دقيقة (يوقف Anti-Raid عندما تضيف أعضاء بنفسك)</li>
                    </ul>
                </CardContent>
            </Card>

            <Card className="bg-card/60 backdrop-blur">
                <CardHeader>
                    <CardTitle className="flex items-center gap-2 text-base">
                        <Server className="h-4 w-4" />
                        التكاملات
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-2 text-sm">
                    <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Backend</span>
                        <Badge variant="outline" className="text-emerald-300 bg-emerald-500/10">
                            FastAPI + aiogram 3.x
                        </Badge>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">AI</span>
                        <Badge variant="outline" className="text-cyan-300 bg-cyan-500/10">
                            Emergent LLM (GPT-4o-mini)
                        </Badge>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Storage</span>
                        <Badge variant="outline">MongoDB</Badge>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
